import * as React from 'react'

function SvgBankFilledBackground(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="200"
      height="200"
      viewBox="0 0 200 200"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        opacity="0.3"
        d="M97.9232 175.097C141.955 174.795 192.824 159.011 191.854 99.4674C190.987 45.4407 142.261 9.87092 99.9877 35.7692C81.7498 46.9354 76.8197 71.028 56.4906 79.0045C36.1614 86.981 7.71032 83.171 5.19593 116.961C1.30208 169.287 68.952 175.305 97.9232 175.097Z"
        fill="#C2FFE7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M160.573 78.9329C164.211 78.9329 167.379 76.4479 168.245 72.9142C169.112 69.3804 167.453 65.7119 164.227 64.0289L103.66 32.4289C101.371 31.2342 98.6415 31.2342 96.3518 32.4289L35.7852 64.0289C32.5594 65.7119 30.9003 69.3804 31.7667 72.9142C32.6331 76.4479 35.801 78.9329 39.4394 78.9329H160.573ZM68.4034 97.3649C68.4034 93.0019 64.8665 89.4649 60.5034 89.4649C56.1404 89.4649 52.6034 93.0019 52.6034 97.3649V128.965C52.6034 133.328 56.1404 136.865 60.5034 136.865C64.8665 136.865 68.4034 133.328 68.4034 128.965V97.3649ZM107.903 97.3649C107.903 93.0019 104.366 89.4649 100.003 89.4649C95.6404 89.4649 92.1034 93.0019 92.1034 97.3649V128.965C92.1034 133.328 95.6404 136.865 100.003 136.865C104.366 136.865 107.903 133.328 107.903 128.965V97.3649ZM139.503 89.4649C143.866 89.4649 147.403 93.0019 147.403 97.3649V128.965C147.403 133.328 143.866 136.865 139.503 136.865C135.14 136.865 131.603 133.328 131.603 128.965V97.3649C131.603 93.0019 135.14 89.4649 139.503 89.4649ZM160.574 163.199C164.937 163.199 168.474 159.662 168.474 155.299C168.474 150.936 164.937 147.399 160.574 147.399H39.4402C35.0771 147.399 31.5402 150.936 31.5402 155.299C31.5402 159.662 35.0771 163.199 39.4402 163.199H160.574Z"
        fill="#00D37E"
      />
    </svg>
  )
}

export default SvgBankFilledBackground
